import { ApiBackClient, ApiCEP } from '../../../services/apiADA';
import { saveInSessionStorage } from '../../../contexts/LocalStorage';

export function buscarClientesModuloClientes(find, doc, username, token, cancelToken) {
    return new Promise((resolve, reject) => {
        ApiBackClient.post("/consultacliente", { "find": find, "cgccpf": doc , "tipvis": "C" },
            {
                headers: {
                    'Content-Type': 'application/json', 
                    username: username,
                    Authorization: `Bearer ${token}`
                },
                baseURL: localStorage.getItem("base_url"),
                cancelToken: cancelToken
            })
            .then(res => {
                saveInSessionStorage("logid", res.headers.logid);
                if (res.data === '') {
                    reject({ cod: 1, error: "Retorno inválido do sistema!" });
                } else {
                    resolve(res.data);
                }
            })
            .catch(function (error) {
                consoleLogErros(error);
                if (error.response !== undefined && error.response.data !== undefined && error.response.data.error !== undefined) {
                    reject({ cod: 1, error: error.response.data.error });
                } else {
                    reject({ cod: 1, error: error });
                }
            });
    });
}

export function buscarRamoAtividade(find, username, token) {
    return new Promise((resolve, reject) => {
        ApiBackClient.post("/ramoatividade", { "find": find},
            {
                headers: {
                    'Content-Type': 'application/json', 
                    username: username,
                    Authorization: `Bearer ${token}`
                },
                baseURL: localStorage.getItem("base_url"),
            })
            .then(res => {
                saveInSessionStorage("logid", res.headers.logid);
                if (res.data === '') {
                    reject({ cod: 1, error: "Retorno inválido do sistema!" });
                } else {
                    resolve(res.data);
                }
            })
            .catch(function (error) {
                consoleLogErros(error);
                if (error.response !== undefined && error.response.data !== undefined && error.response.data.error !== undefined) {
                    reject({ cod: 1, error: error.response.data.error });
                } else {
                    reject({ cod: 1, error: error });
                }
            });
    });
}
export function buscarSegmento(find, username, token) {
    return new Promise((resolve, reject) => {
        ApiBackClient.post("/segmento", { "find": find},
            {
                headers: {
                    'Content-Type': 'application/json', 
                    username: username,
                    Authorization: `Bearer ${token}`
                },
                baseURL: localStorage.getItem("base_url"),
            })
            .then(res => {
                saveInSessionStorage("logid", res.headers.logid);
                if (res.data === '') {
                    reject({ cod: 1, error: "Retorno inválido do sistema!" });
                } else {
                    resolve(res.data);
                }
            })
            .catch(function (error) {
                consoleLogErros(error);
                if (error.response !== undefined && error.response.data !== undefined && error.response.data.error !== undefined) {
                    reject({ cod: 1, error: error.response.data.error });
                } else {
                    reject({ cod: 1, error: error });
                }
            });
    });
}

export function infoCliente(codCli, username, token) {
    return new Promise((resolve, reject) => {
        ApiBackClient.post("/infocliente", { "cliente": codCli },
            {
                headers: {
                    'Content-Type': 'application/json',
                    username: username,
                    Authorization: `Bearer ${token}`
                },
                baseURL: localStorage.getItem("base_url")
            })
            .then(res => {
                saveInSessionStorage("logid", res.headers.logid);
                if (res.data === '') {
                    console.error(res.data);
                    reject({ cod: 1, error: "Retorno inválido do sistema!" });
                } else {
                    resolve(res.data);
                }
            })
            .catch(function (error) {
                consoleLogErros(error);
                if (error.response !== undefined && error.response.data !== undefined && error.response.data.error !== undefined) {
                    reject({ cod: 1, error: error.response.data.error });
                } else {
                    reject({ cod: 1, error: error });
                }
            });
    });
}

export function enviarNovoClienteERP(cliente, username, token) {
    return new Promise((resolve, reject) => {
        ApiBackClient.post("/cliente", cliente,
            {
                headers: {
                    'Content-Type': 'application/json', 
                    username: username,
                    Authorization: `Bearer ${token}`
                },
                baseURL: localStorage.getItem("base_url")
            })
            .then(res => {
                saveInSessionStorage("logid", res.headers.logid);
                if (res.data === '') {
                    reject({ cod: 1, error: "Retorno inválido do sistema!" });
                } else {
                    resolve(res.data);
                }
            })
            .catch(function (error) {
                consoleLogErros(error);
                if (error.response !== undefined && error.response.data !== undefined) {
                    reject(error.response.data);
                } else {
                    reject(error);
                }
            });
    });
}

export function consultarCNPJ(cnpj, uf, username, token) {
    return new Promise((resolve, reject) => {
        ApiBackClient.post("/cnpj", {"cnpj": cnpj, "uf": uf},
            {
                headers: {
                    'Content-Type': 'application/json', 
                    username: username,
                    Authorization: `Bearer ${token}`
                },
                baseURL: localStorage.getItem("base_url")
            })
            .then(res => {
                saveInSessionStorage("logid", res.headers.logid);
                if (res.data === '') {
                    reject({ cod: 1, error: "Retorno inválido do sistema!" });
                } else {
                    resolve(res.data);
                }
            })
            .catch(function (error) {
                consoleLogErros(error);
                if (error.response !== undefined && error.response.data !== undefined) {
                    reject(error.response.data);
                } else {
                    reject(error);
                }
            });
    });
}

export function buscarCEPCliente(cep) {
    return new Promise((resolve, reject) => {
        ApiCEP.get(`/${cep}/json/`)
            .then(res => {
                if (res.data === '') {
                    reject({ cod: 1, error: "Retorno inválido do sistema!" });
                } else {
                    resolve(res.data);
                }
            })
            .catch(function (error) {
                consoleLogErros(error);
                if (error.response !== undefined && error.response.data !== undefined && error.response.data.error !== undefined) {
                    reject({ cod: 1, error: error.response.data.error });
                } else {
                    reject({ cod: 1, error: error });
                }
            });
    });
}

function consoleLogErros(error) {
    if (error.response) {
        // Requisição feita e o servidor retornou um erro
        console.error(error.response.data);
        console.error(error.response.status);
        console.error(error.response.headers);
    } else if (error.request) {
        // A requisição foi feita, mas nenhuma resposta foi recebida
        console.error(error.request);
    } else {
        // Alguma coisa aconteceu nas configurações da requisição que gerou um erro
        console.error('Error', error.message);
    }
}